import React, { useState } from 'react';
import axios from '../../hooks/fetchWithAuth';
import { Paper, Button } from '@mui/material';
import { Flex } from "../../style";
import "../../index.css";
import config from '../../config';
import './style.css';
import getCookie from '../../hooks/getCookie';
import MentionTextArea from '../MentionTextArea';

const EditableTextField2 = ({ text, selectedCard, placeholder, fetchTiBoardData, listComments, comments, setComments }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(text);
    const [mentionData, setMentionData] = useState({ mentions: [], textContent: '' });
    const username = getCookie("username");
    const nameComplete = getCookie("nome_completo");
    const sessionId = getCookie("session_id");
    
    const backendIp = config.backend_ip;

    const handleCancelComment = () => {
        setValue('');
        setIsEditing(false);
    };

    const handleValueChange = (content, additionalData) => {
        setValue(content);
        if (additionalData) {
            setMentionData(additionalData);
        }
    };

    const handleSaveComment = async () => {
        if (value.trim() !== '') {
            // Remove tags de menção e converte para texto plano @username
            let cleanedValue = value
                .replace(/<\/p><p>/g, '\n')
                .replace(/^<p>/, '')
                .replace(/<\/p>$/, '')
                .replace(/&nbsp;/g, ' ')
                .replace(/<br>/g, '\n');
            // Remove <span class="ql-mention" ...>@username</span> => @username
            cleanedValue = cleanedValue.replace(/<span class="ql-mention"[^>]*data-value="([^"]+)"[^>]*>[^<]*<\/span>/g, '@$1');

            try {
                const response = await axios.put(`${backendIp}/api/board/ti/add_comment`, {
                    card_id: selectedCard.id,
                    comment_text: cleanedValue, // Envia texto plano com menções
                    created_by: username,
                    comment_created_by_name: nameComplete,
                    user: username,
                    session_id: sessionId,
                    mentions: mentionData.mentions || []
                });

                const result = response.data;
                setValue('');
                setMentionData({ mentions: [], textContent: '' });
                setIsEditing(false);

                fetchTiBoardData(selectedCard);

                return result;

            } catch (error) {
                return null;
            }
        }
    };

    return (
        <div className='comment-box'>
            {isEditing ? (
                <div>
                    <MentionTextArea
                        value={value}
                        onChange={handleValueChange}
                        onSave={handleSaveComment}
                        onCancel={handleCancelComment}
                        placeholder={placeholder}
                        selectedCard={selectedCard}
                    />
                    <Flex style={{marginBottom:'10px', marginTop:'10px'}}>
                        <Button onClick={handleSaveComment} className='comment-button' variant='contained'>
                            Salvar
                        </Button>
                        <Button onClick={handleCancelComment} className='comment-cancel'>
                            Cancelar
                        </Button>
                    </Flex>
                </div>
            ) : (
                <Paper
                    elevation={2}
                    onClick={() => setIsEditing(true)}
                    style={{  padding: 10, cursor: 'pointer', wordWrap: 'break-word'}}
                    className='textfield-dark'
                >
                    {text || placeholder}
                </Paper>
            )}
        </div>
    );
};

export default EditableTextField2;